module.exports = __webpack_public_path__ + "img/home_middle_amount.23ae4ab8.png";